export type InstanceCredentials = {
  id: string;
  username: string;
  password: string;
  boltUrl: string;
  name: string;
  databaseName?: string;
};

export const formatInstanceCredentials = (credentials: InstanceCredentials) => {
  const { id, username, password, boltUrl, name, databaseName } = credentials;
  const content: string =
    '# Wait 60 seconds before connecting using these details, or login to https://console.neo4j.io to validate the Aura Instance is available\n' +
    `NEO4J_URI=${boltUrl}\n` +
    `NEO4J_USERNAME=${username}\n` +
    `NEO4J_PASSWORD=${password}\n` +
    `NEO4J_DATABASE=${databaseName}\n` +
    `AURA_INSTANCEID=${id}\n` +
    `AURA_INSTANCENAME=${name}\n`;

  return content;
};
